import { useMainContext } from '@context/Main';
import { UntactDepartment, UntactTvBanner } from '@api/GoodocAPI';
import UntactDepartmentItem from '../UntactDepartmentItem';
import UntactBannerItem from '../UntactBannerItem';
import * as styles from './styles';

const UntactDepartmentList = () => {
  const {
    untactDepartmentsWithBanner,
    scrollRef,
    onFocus,
    moveToDoctorSelect,
    showAdvertisement,
    hideAdvertisement,
    navigateAdvertisePage
  } = useMainContext();

  return (
    <div css={styles.container}>
      <div css={styles.scrollContainer} ref={scrollRef}>
        {untactDepartmentsWithBanner?.map((untactDepartmentWithBanner, index) => {
          if (untactDepartmentWithBanner.objectType === 'UntactDepartment') {
            const department = untactDepartmentWithBanner.object as UntactDepartment;

            return (
              <UntactDepartmentItem
                key={`${index}`}
                index={index}
                name={department.name}
                imageUrl={department.tvImageUrl || undefined}
                onFocus={onFocus}
                onEnterPress={() => moveToDoctorSelect(department)}
                hideAdvertisement={hideAdvertisement}
              />
            );
          } else if (untactDepartmentWithBanner.objectType === 'UntactTvBanner') {
            const banner = untactDepartmentWithBanner.object as UntactTvBanner;

            return (
              <UntactBannerItem
                key={`${index}`}
                index={index}
                banner={banner}
                onFocus={onFocus}
                showAdvertisement={showAdvertisement}
                onEnterPress={navigateAdvertisePage}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default UntactDepartmentList;
